<template>
  <div id="order-filters-anchor-links">
    <p id="undefined-from-filters" :counterTextObserver="productObserver"></p>
    <Observer :options="getObserverOptions" />
    <div class="filters-wrap1">
      <div class="order-filters flex-row align-items-start">
        <div
          v-for="(item, index) in filters"
          :key="index"
          :class="filterClasses[item.type]"
          @click="handleFiltersClick(item, $event, index)"
          :dependentComputedProps="{
            appliedFilters,
          }"
        >
          <i :class="filterIconPre[item.type]"></i>
          <div class="order-filter-title">{{ item.title }}</div>
          <!-- <i :class="filterIconPost[item.viewType]"></i> -->
        </div>
      </div>

      <!-- <div class="fs-11 lh16">
            <horizontal-banner-with-anchor-links></horizontal-banner-with-anchor-links>
          </div> -->
    </div>
    <!-- filter select popup -->
    <!-- <generic-modal
      v-if="showMilestoneModal"
      @close="closeModal()"
      :height="msModalDim.height"
      :width="msModalDim.width"
      :animationStyle="msModalDim.animationStyle"
      :genericModalSource="'OrderFiltersPopup'"
    >
      <template v-slot:header>
        <p class="modal-title fs-18 lh25 bold mb20 ml10">Sort by</p>
        <i @click="closeModal(true)" class="jfi-cross sticky-pop-cross"></i>
      </template>
      <template v-slot:body>
        <ul class="list-wrap">
          <li
            class="list-item fs-14 lh20 pl10 pt10 pb10 flex-row"
            v-for="(item, index) in sortOptions"
            :key="index"
            @click="applyFilter($event, item)"
          >
            <span
              :class="{ dot: appliedSortFilters[0]?.title == item.title }"
              >{{ item.title }}</span
            >
            <span><i class="jfi-arrow-line ml7"></i></span>
          </li>
        </ul>
        <p
          class="clear-sort-cta fs-12 lh18 bold flex-row hand color-secondary"
          @click="clearSortFilter($event)"
          v-if="appliedSortFilters[0]"
        >
          Reset
        </p>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal> -->
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import "vue3-carousel/dist/carousel.css";
import { keyMapsMutation, keyMapsGetter } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import { setEvents } from "../helpers/analyticsEvents";
import LocalStorageFunc from "../helpers/localStorageFunc";
// import userActivityTracking from "../helpers/UserActivityTracking";
import { defineAsyncComponent } from "vue";
import Observer from "./Observer.vue";
import { VWO_HOMEPAGE_EXPERIMENT } from "../config/vwoKeys";
import {
  EVENT_CLICK_FILTERS,
  EVENT_VEG_MODE,
} from "../helpers/analyticsEvents";

export default {
  name: "FilterMenuAnchorLinks",
  props: ["dataResults", "moduleProps"],

  components: {
    GenericModal,
    HorizontalNavWithAnchorLinks: defineAsyncComponent(() =>
      import("./HorizontalNavWithAnchorLinks.vue")
    ),
    Observer,
  },

  data() {
    return {
      msModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px)",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "modal-bg-blackout",
      },
      showMilestoneModal: false,
      filterIconPre: {
        VEG: "tag-veg mr5",
        NONVEG: "tag-non-veg mr5",
      },
      filterIconPost: {
        select: "jfi-arrow-line ml7",
        sort: "jfi-arrow-switch ml7",
      },
      filterClasses: {},
      filters: [],
      sortOptions: [],
      // appliedFilters: [],
      appliedSortFilters: [],
      cachedComponentOffsetTop: 0,
      preWindowYOffset: 0,
      eleIdToObserve: "undefined-from-filters",
      resetFilter: true,
    };
  },

  mounted() {
    let dR = (this.dataResults && JSON.parse(this.dataResults)) || [];

    this.filters = dR.filter((_) => {
      return _.group == "FILTER";
    });
    this.sortOptions = dR.filter((_) => {
      return _.group == "SORT";
    });

    this.loadInitialFilters();
    // if (
    //   this.productObserver &&
    //   this.eleIdToObserve &&
    //   document.getElementById(this.eleIdToObserve)
    // ) {
    //   this.productObserver.observe(
    //     document.getElementById(this.eleIdToObserve)
    //   );
    // }
  },

  destroyed() {
    if (this.observer) {
      this.observer.unobserve(document.getElementById(this.eleIdToObserve));
    }
  },

  methods: {
    handleFiltersClick(item, e, index) {
      // userActivityTracking.filterApplied(item.title, index, 0);
      //Amplitude Click event load
      // const preEventObj = {
      //   positionWithinSection: index + 1,
      //   category:
      //     item.title?.toLowerCase() == "sort by"
      //       ? "sortby popup"
      //       : item.title?.toLowerCase(),
      // };
      // const eventObj = Utility.amplitudeEventObj(
      //   "click",
      //   "filters",
      //   "6",
      //   preEventObj
      // );
      // setEvents("amplitude", "Click", eventObj);

      if (item.group == "SORT" || item.options?.length > 0) {
        this.triggerModal(e);
      } else {
        this.applyFilter(item, e, index);
      }
    },
    loadInitialFilters() {
      this.$store.commit(keyMapsMutation.UPDATE_APPLIED_FILTERS_AND_SORTS, {
        FILTERS: ["ALL"],
        SORTS: [],
      });
    },
    applyFilter(item, e, index) {
      EVENT_VEG_MODE({
        userAction: item?.title,
      });
      if (this.appliedFilters.includes(item.type)) {
        this.$store.commit(keyMapsMutation.UPDATE_APPLIED_FILTERS_AND_SORTS, {
          FILTERS: ["ALL"],
          SORTS: this.appliedSorts,
        });
        EVENT_CLICK_FILTERS({
          category: item.title,
          subCategory: "filter unchecked",
          positionWithinSection: index + 1,
        });
      } else {
        this.$store.commit(keyMapsMutation.UPDATE_APPLIED_FILTERS_AND_SORTS, {
          FILTERS: [item.type],
          SORTS: this.appliedSorts,
        });
        EVENT_CLICK_FILTERS({
          category: item.title,
          subCategory: "filter checked",
          positionWithinSection: index + 1,
        });
      }
      this.closeModal();
    },
    triggerModal(e) {
      document.body.classList.add("body-stop-scroll-mobile");
      this.showMilestoneModal = true;
      //Amplitude Impression event load
      // const eventObj = Utility.amplitudeEventObj("impression", "filters", "6", {
      //   category: "sortby popup",
      // });
      // setEvents("amplitude", "Impression", eventObj);
    },
    closeModal(isCrossClicked = false) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showMilestoneModal = false;
      if (isCrossClicked) {
        //Amplitude Click event load
        // const preEventObj = {
        //   positionWithinSection: "top right",
        //   category: "sortby popup",
        //   subCategory: "cross tap",
        // };
        // const eventObj = Utility.amplitudeEventObj(
        //   "click",
        //   "filters",
        //   "6",
        //   preEventObj
        // );
        // setEvents("amplitude", "Click", eventObj);
      }
    },
    // resetFilterRelatedUI() {
    //   this.appliedFilters = [];
    //   this.appliedSortFilters = [];
    //   this.filters.map((_) => {
    //     this.filterClasses[_.title] =
    //       "order-filter-item flex-row fs-12 lh-18  ml3 mr3";
    //   });
    // },
    // loadOrderFiltersFromSession() {
    //   this.filters.map((_) => {
    //     this.filterClasses[_.title] =
    //       "order-filter-item flex-row fs-12 lh-18  ml3 mr3";
    //   });

    //   let _ = LocalStorageFunc.getSessionStorageKey("orderFiltersData");
    //   _.appliedFilters?.forEach((item) => {
    //     this.applyFilter("", item);
    //   });
    //   _.appliedSortFilters?.forEach((item) => {
    //     this.applyFilter("", item);
    //   });
    // },
    updateProductCounterString(productCounter) {
      this.$store.commit(
        keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
        productCounter
      );
    },
  },
  computed: {
    getRecommendedProducts() {
      return this.$store.getters[keyMapsGetter.GET_RECOMMENDED_PRODUCTS]();
    },
    getBottomBarData() {
      return this.$store.state.ProductItems.productCategory;
    },
    isTrueLocationDetected() {
      return this.$store.state.Location.isTrueLocationDetected;
    },
    productCounterString() {
      return this.$store.state.ProductItems.productCounterString;
    },
    productObserver() {
      let observer = this.$store.state.ProductItems.productObserver;
      if (
        observer &&
        this.eleIdToObserve &&
        document.getElementById(this.eleIdToObserve)
      ) {
        observer.observe(document.getElementById(this.eleIdToObserve));
      }
      return observer;
    },
    shouldVisible() {
      return this.isTrueLocationDetected || this.isLocationPermisssionGiven;
    },
    getObserverOptions() {
      // if (Utility.isSeparateMenuVariant()) {
      //   this.resetFiltersAndInsertCounterString;
      //   return { root: null, threshold: 0, rootMargin: "0%" };
      // } else {
      //   return { rootMargin: "-50px" };
      // }
      this.resetFiltersAndInsertCounterString;
      return { root: null, threshold: 0, rootMargin: "0%" };
    },
    resetFiltersAndInsertCounterString() {
      let productItems = this.getBottomBarData;
      if (this.resetFilter && Object.keys(productItems).length > 0) {
        this.resetFilter = false;
        let queryParams = Utility.getQueryFromUrl();
        let scrollToParam =
          queryParams["scrollTo"] ||
          queryParams["cat_id"] ||
          queryParams["categoryId"] ||
          "";
        let onScroll;
        if (scrollToParam !== undefined && scrollToParam !== "") {
          onScroll = scrollToParam;
        } else {
          onScroll =
            productItems[Object.keys(productItems)[0]]?.metadataMap?.categoryId
              ?.values[0];
        }
        let keyFound = false;
        for (const product of productItems) {
          if (product?.metadataMap?.categoryId?.values[0] === onScroll) {
            keyFound = true;
            this.$store.commit(
              keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
              product.nodeName
            );
            break;
          }
        }
        if (!keyFound && !this.$store.state.ProductItems.productCounterString) {
          this.$store.commit(
            keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
            this.getCategoryNameAndCountForBottomBar?.find((x) => x.count)
              ?.categoryName
          );
        }

        // this.resetAllFilters;
      }
    },
    resetAllFilters() {
      this.appliedSortFilters = [];
      this.filterIconPost.sort = "jfi-arrow-switch ml7";
      LocalStorageFunc.setSessionStorageKey("orderFiltersData", {});
      this.$store.commit(keyMapsMutation.FILTER_PRODUCT_ITEMS, {
        filterProductItem: [],
        cartData: this.$store.state.Cart.cartItems,
        cartQuantitiy: this.$store.getters["Cart/cartQuantity"],
      });
      this.loadOrderFiltersFromSession();
    },
    isLocationPermisssionGiven() {
      return this.$store.state.Location.isLocationPermissionGiven;
    },
    appliedFilters() {
      let flts = this.$store.getters[keyMapsGetter.GET_APPLIED_FILTERS];
      this.filters.map((flt) => {
        if (flts.includes(flt.type)) {
          this.filterClasses[flt.type] =
            "order-filter-item flex-row fs-12 lh-18 ml5 selected-filter-item";
        } else {
          this.filterClasses[flt.type] =
            "order-filter-item flex-row fs-12 lh-18 ml5";
        }
      });
      return flts || [];
    },
    getCategoryNameAndCountForBottomBar() {
      let productItems =
        this.$store.getters[
          keyMapsGetter.GET_CATEGORY_NAME_AND_COUNT_FOR_BOTTOM_BAR
        ];
      return productItems;
    },
  },
  watch: {
    getBottomBarData: {
      handler(newVal, oldVal) {
        if (newVal.length > 0 && this.resetFilter) {
          this.resetFiltersAndInsertCounterString;
        }
      },
    },
  },
};
</script>

<style scoped></style>
